let base_url = process.env.VUE_APP_PUBLIC_PATH || "/";

module.exports = {
    publicPath: base_url,
    transpileDependencies: ["@vueform"],
    chainWebpack: config => {
        config.module.rules.delete('eslint');
    }
}


// const webpack = require("webpack");

// module.exports = {
//   publicPath: process.env.VUE_APP_PUBLIC_PATH || "/",
//   transpileDependencies: ["@vueform"],

//   configureWebpack: {
//     resolve: {
//       fallback: {
//         "stream": require.resolve("stream-browserify"),
//         "path": require.resolve("path-browserify"),
//         "util": require.resolve("util/"),
//         "https": require.resolve("https-browserify"),
//         "http": require.resolve("stream-http"),
//         "os": require.resolve("os-browserify/browser"),
//         "crypto": require.resolve("crypto-browserify"),
//         "querystring": require.resolve("querystring-es3"),
//         "browserify-zlib": require.resolve("browserify-zlib"),
//         "tty": require.resolve("tty-browserify"),
//         "vm": require.resolve("vm-browserify"),
//         "url": require.resolve("url/")
//       }
//     },
//     plugins: [
//       new webpack.ProvidePlugin({
//         process: 'process/browser'
//       })
//     ]
//   },

//   chainWebpack: config => {
//     config.module.rules.delete("eslint");
//   }
// };


